import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

const DialogHeader = ({ summary }) => {
  return (
    <div style={styles.header}>
      Delete events from {summary}
    </div>
  )
}

DialogHeader.propTypes = {
  summary: PropTypes.string
}

const DialogFooter = ({ onDeleteClicked, onCancelClicked }) => (
  <div style={styles.footer}>
    <FlatButton
      key='delete'
      label='Delete'
      primary={true}
      onTouchTap={onDeleteClicked} />
    <FlatButton
      key='cancel'
      labelStyle={styles.importActionLabel}
      label='Cancel'
      onTouchTap={onCancelClicked} />
  </div>
)

DialogFooter.propTypes = {
  onDeleteClicked: PropTypes.func.isRequired,
  onCancelClicked: PropTypes.func.isRequired
}

const DialogContent = ({ summary }) => {
  return (
    <div style={styles.contentBody}>
      <div style={styles.info}>
        <div style={styles.infoTip}>
          This will delete all events that were imported from <b>{summary}</b>.
        </div>
        <div style={styles.infoTip}>
          Do you want to delete this calendar?
        </div>
      </div>
    </div>
  )
}

DialogContent.propTypes = {
  summary: PropTypes.string
}

export default class RemoveImportedCalendarDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool,
    calendarSummary: PropTypes.string,
    onRemoveCancelled: PropTypes.func.isRequired,
    onRemoveConfirmed: PropTypes.func.isRequired
  }

  handleCancelClicked = event => {
    event.preventDefault()
    this.props.onRemoveCancelled()
  }

  handleDeleteClicked = event => {
    event.preventDefault()
    this.props.onRemoveConfirmed()
  }

  render() {
    return (
      <Dialog open={this.props.open}
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}>
        <DialogHeader summary={this.props.calendarSummary} />
        <DialogContent summary={this.props.calendarSummary}/>
        <DialogFooter
          onDeleteClicked={this.handleDeleteClicked}
          onCancelClicked={this.handleCancelClicked} />
      </Dialog>
    )
  }

}

const styles = {

  dialogContent: {
    borderRadius: 2,
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto',
    width: 360
  },

  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    borderRadius: 2
  },

  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: 16
  },

  contentBody: {
    padding: 24
  },

  header: {
    padding: 16,
    borderRadius: 2,
    fontWeight: 500,
    fontFamily: 'Roboto',
    fontSize: 15,
    backgroundColor: '#f7f7f7',
    color: 'rgba(0, 0, 0, 0.71)',
    boxShadow: 'inset 0 1px 0 0 rgba(0, 0, 0, 0.05)'
  },

  info: {
    display: 'flex',
    flexDirection: 'column'
  },

  infoTip: {
    marginBottom: 12,
    fontWeight: 400,
    fontFamily: 'Roboto',
    fontSize: 15,
    paddingTop: 6,
    paddingBottom: 6
  }

}



// WEBPACK FOOTER //
// ./src/schedule/gcal/RemoveImportedCalendarDialog.js